export default "__VITE_ASSET__DPi5pgwT__"